import api from './api';
import { Invitation, InvitationCreate } from '../types';

export const invitationService = {
  async create(data: InvitationCreate): Promise<Invitation> {
    const response = await api.post('/invitations/create', data);
    return response.data;
  },

  async list(): Promise<Invitation[]> {
    const response = await api.get('/invitations/list');
    return response.data;
  },

  async delete(id: number): Promise<void> {
    await api.delete(`/invitations/${id}`);
  }
};
